// extracted by mini-css-extract-plugin
module.exports = {"aboutAuthor":"Author_aboutAuthor__71pYQ","description":"Author_description___3_hw"};